/**
 * Le champ « moyens techniques » d'un studio se saisit à trois endroits : le formulaire studio
 * admin, son équivalent prestataire et l'onboarding professeur. Les trois réécrivaient le libellé
 * et le placeholder à la main.
 */
export const STUDIO_EQUIPMENT_DESCRIPTION_LABEL = "Description des moyens techniques du studio";

export const STUDIO_EQUIPMENT_DESCRIPTION_PLACEHOLDER =
  "Décrivez les moyens techniques disponibles dans le studio (piano, pupitre, partitions, tabouret, insonorisation, ...)";
